import { useContext, useMemo } from 'react';
import MantineTable from '../../../common/table/mantine';
import { ActionIcon, Button, Grid } from '@mantine/core';
import { Context, FormItem } from './context';
import { AppLoader } from '../../../components/common/loader';
import { IconPlus } from '@tabler/icons-react';
import { CustomSelect } from '../styles';

export const Form = () => {
  const { fetch, loading, form, setForm, skus, countries, codes, onFormChange, initialLoading } =
    useContext(Context);

  const columns = useMemo(() => {
    const getCountryCodes = (country) => {
      if (!country) return [];
      return Object.keys(codes).filter((code) => codes[code] === country);
    };

    const selectedBuyerCountries = form.map((f) => f.buyer_country).filter(Boolean);
    const selectedBrewerCountries = form.map((f) => f.brewer_country).filter(Boolean);

    return [
      // {
      //   id: 'action',
      //   header: '',
      //   Cell: ({ row: { index } }) => {
      //     return index > 0 ? (
      //       <ActionIcon onClick={() => handleRemove(index)}>
      //         <IconTrash size='4.125rem' color='red' />
      //       </ActionIcon>
      //     ) : null;
      //   },
      // },
      {
        accessorKey: 'sku',
        header: 'SKU',
        Cell: ({
          row: {
            index,
            original: { error },
          },
        }) => (
          <CustomSelect
            placeholder='SKU'
            searchable
            data={skus}
            onChange={(value) => onFormChange(index, 'sku', value)}
            error={error}
            withinPortal
          />
        ),
      },
      {
        accessorKey: 'buyer_country',
        header: 'Buying Country',
        Cell: ({ row: { index, original } }) => {
          const availableCountries = countries.filter(
            (country) =>
              !selectedBuyerCountries.includes(country) || country === original.buyer_country,
          );
          return (
            <CustomSelect
              placeholder='Buying Country'
              searchable
              data={availableCountries}
              onChange={(value) => onFormChange(index, 'buyer_country', value)}
              error={original.error}
              withinPortal
            />
          );
        },
      },
      {
        accessorKey: 'buyer_code',
        header: 'Buyer Code',
        Cell: ({
          row: {
            index,
            original: { buyer_country, error },
          },
        }) => {
          const countryCodes = getCountryCodes(buyer_country);
          return (
            <CustomSelect
              placeholder='Buyer Code'
              searchable
              data={countryCodes}
              disabled={!buyer_country}
              onChange={(value) => onFormChange(index, 'buyer_code', value)}
              error={error}
              withinPortal
            />
          );
        },
      },
      {
        accessorKey: 'brewer_country',
        header: 'Brewer Country',
        Cell: ({ row: { index, original } }) => {
          const availableCountries = countries.filter(
            (country) =>
              country !== original.buyer_country &&
              (!selectedBrewerCountries.includes(country) || country === original.brewer_country),
          );
          return (
            <CustomSelect
              placeholder='Brewer Country'
              searchable
              data={availableCountries}
              disabled={!original.buyer_country}
              onChange={(value) => onFormChange(index, 'brewer_country', value)}
              error={original.error}
              withinPortal
            />
          );
        },
      },
      {
        accessorKey: 'brewer_code',
        header: 'Brewer Code',
        Cell: ({
          row: {
            index,
            original: { brewer_country, error },
          },
        }) => {
          const countryCodes = getCountryCodes(brewer_country);
          return (
            <CustomSelect
              placeholder='Brewer Code'
              searchable
              data={countryCodes}
              disabled={!brewer_country}
              onChange={(value) => onFormChange(index, 'brewer_code', value)}
              error={error}
              withinPortal
            />
          );
        },
      },
    ];
  }, [skus, countries, codes, form, onFormChange]);

  const handleAddNew = () => {
    setForm([...form, { ...FormItem }]);
  };

  const handleRemove = (index) => {
    const currentRows = [...form];
    currentRows.splice(index, 1);

    setForm(currentRows);
  };

  const canSubmit = () => {
    const index = form.findIndex(
      ({ sku, buyer_country, brewer_country }) => !sku || !buyer_country || !brewer_country,
    );
    return index === -1 && form.length > 0;
  };

  return (
    <>
      <MantineTable
        columns={columns}
        initialData={form}
        enablePagination={false}
        enableSorting
        enableBottomToolbar={false}
        enableTopToolbar={false}
        enableColumnFilters={false}
        enableColumnActions={false}
        enableZoom={false}
        loading={initialLoading}
        mantineTableHeadProps={{
          sx: {
            '& tr': {
              backgroundColor: '#D8D8D8',
              '& .mantine-TableHeadCell-Content': {
                color: '#1E1E1E',
              },
            },
          },
        }}
      />
      <Grid>
        <Grid.Col md={2}>
          {form.length <= 20 && (
            <Button variant='subtle' disabled={loading} onClick={handleAddNew} compact>
              <IconPlus size='1rem' style={{ marginRight: '5px' }} /> Add new entry
            </Button>
          )}
        </Grid.Col>
        <Grid.Col offset={8} md={2}>
          <br />
          <Button
            variant='gradient'
            color='dark'
            fullWidth
            disabled={!canSubmit() || loading}
            onClick={fetch}
          >
            {loading ? <AppLoader size='sm' variant='dark' /> : 'Search'}
          </Button>
        </Grid.Col>
      </Grid>
    </>
  );
};
